module.exports = __webpack_public_path__ + "static/media/MyOpinion_Logo_Head.2c47fa19.png";